<template>
  <div class="app-header" :style="{ background: background}">
    <div class="header-content">
      <div class="logo" @click="$router.push('/')"></div>
      <ul class="nav">
        <li
          v-for="item in navConfig"
          :key="item.name"
          class="nav-item">
          <a href="#" @click.prevent="onMenuClick(item)">{{item.title}}</a>
          <div
            v-if="item.tips && item.tips.show"
            class="nav-tips">
            <div class="nav-tips-content" :style="{ width: item.tips.width }">
              <p v-for="text in item.tips.text" :key="text">{{text}}</p>
            </div>
          </div>
          <ul
            v-show="showSubMenu"
            v-else-if="item.children && item.children.length > 0"
            class="sub-nav">
            <li
              v-for="child in item.children"
              :key="child.name"
              class="sub-nav-item">
              <a href="#" @click.prevent="onMenuClick(child)">{{child.title}}</a>
            </li>
          </ul>
        </li>
      </ul>
      <div class="right">
        <a href="#" @click.prevent="$root.$emit('tryout')">免费试用</a>
      </div>
    </div>
  </div>
</template>

<script>
import navConfig from './nav.config';

export default {
  data() {
    return {
      navConfig,
      background: 'rgba(0, 0, 0, 0.05)',
      showSubMenu: true,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (val.meta.darkHeader) {
          this.background = 'rgba(37, 50, 140, 1)';
        }
      },
    },
  },
  mounted() {
    this.changeBackground();
    window.addEventListener('scroll', this._onScroll = () => {
      if (this.$route.meta.darkHeader) return;
      this.changeBackground();
    });
  },
  beforeDestroy() {

  },
  methods: {
    changeBackground() {
      if (document.documentElement.scrollTop <= 68) {
        this.background = 'rgba(0, 0, 0, 0.05)';
      } else {
        this.background = 'rgba(37, 50, 140, 1)';
      }
    },
    onMenuClick(item) {
      if (item.path) {
        if (item.path === this.$route.path) return;

        this.$router.push(item.path);
        this.showSubMenu = false;
        setTimeout(() => {
          this.showSubMenu = true;
        }, 200);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @mixin header-sub-content {
    position: absolute;
    top: 100%;
    width: 182px;
    left: 50%;
    transform: translateX(-50%);
    background: #ffffff;
    box-shadow: 0 0 4px #999;
    padding: 15px 0;
    box-sizing: border-box;
    display: none;

    &:before {
      position: absolute;
      top: -16px;
      left: 50%;
      transform: translateX(-50%);
      content: '';
      display: block;
      border: 8px solid transparent;
      border-bottom-color: #ffffff;
    }
  }

  .app-header {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: $header-height;

    .header-content {
      min-width: 680px;
      max-width: $content-width;
      height: $header-height;
      margin: 0 auto;

      > .right {
        float: right;
        display: inline-block;
        color: #ffffff;
        height: $header-height;
        line-height: $header-height;
        font-size: 18px;

        a {
          color: inherit;
          text-decoration: none;
        }
      }
    }

    .logo {
      display: inline-block;
      vertical-align: middle;
      width: 40px;
      height: 40px;
      background: url("../../assets/images/logo.png") center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }

    .nav {
      display: inline-block;
      vertical-align: middle;
      height: $header-height;
      line-height: $header-height;
      list-style: none;
      margin-left: 50px;

      .nav-item {
        position: relative;
        display: inline-block;
        font-size: 18px;

        & + .nav-item {
          margin-left: 34px;
        }

        &:hover {
          .sub-nav,
          .nav-tips {
            display: block;
          }
        }

        a {
          display: block;
          height: 100%;
          color: #ffffff;
          text-decoration: none;
          cursor: pointer;
        }
      }
    }

    .sub-nav {
      @include header-sub-content;

      .sub-nav-item {
        height: 40px;
        line-height: 40px;
        font-size: 16px;

        a {
          display: block;
          height: 100%;
          color: #333333;
          text-align: center;

          &:hover {
            color: #ffffff;
            background: #4511bc;
          }
        }
      }
    }

    .nav-tips {
      @include header-sub-content;
      padding: 0;
      box-shadow: none;

      .nav-tips-content {
        background: #ffffff;
        box-shadow: 0 0 4px #999;
        padding: 25px;
        box-sizing: border-box;

        p {
          margin: 0;
          line-height: 22px;
          color: #333333;
          font-size: 14px;
          text-indent: 2em;
          word-break: break-word;
        }
      }
    }
  }
</style>
